export default __webpack_public_path__ + "static/media/onboarding_img.89e97608.png";